import {Box, HStack, Icon, Text} from 'platform/foundation';
import styled from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

interface AdServerRelativeFiltersDropdownFooterProps extends TestIdProps {
  label: string;
  isDisabled: boolean;
  onClick: () => void;
}

export function AdServerRelativeFiltersDropdownFooter(
  props: AdServerRelativeFiltersDropdownFooterProps
) {
  return (
    <Box
      flexShrink={0}
      paddingTop={2}
      borderTop="1px solid"
      borderColor="general.separator"
      backgroundColor="general.white"
    >
      <CreateNewButton
        type="button"
        onClick={props.onClick}
        disabled={props.isDisabled}
        data-testid={suffixTestId('createNew', props)}
      >
        <HStack spacing={1} align="center">
          <Icon value="content/add" size={4} color="text.primary" />
          <Text size="small" alternative>
            {props.label}
          </Text>
        </HStack>
      </CreateNewButton>
    </Box>
  );
}

const CreateNewButton = styled.button`
  display: block;
  width: 100%;
  padding: ${({theme}) => theme.getSize(2)};
  border: none;
  border-radius: ${({theme}) => theme.radii.small};
  background-color: ${({theme}) => theme.colors.palettes.white[10][100]};
  color: ${({theme}) => theme.colors.text.primary};
  font: inherit;
  text-align: left;
  cursor: pointer;

  &:hover:not(:disabled) {
    background-color: ${({theme}) => theme.colors.palettes.blue[10][100]};
  }

  &:focus-visible {
    background-color: ${({theme}) => theme.colors.palettes.blue[10][100]};
    outline: none;
    box-shadow: ${({theme}) => theme.shadows.active};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;
